// T271(5) — one segmented control.
//
// There were two, near-identical, in DashboardPage and ApplicationsPage. Only
// one of them received T252's accessibility fix (role="group" + aria-pressed),
// so on the Applications board the active filter was carried by colour alone
// and a screen reader heard three identical buttons. That is what duplicated
// components cost: a fix lands on the copy the author had open.
//
// Kept deliberately small — a label, a row of options, one active value.
export default function SegmentedControl({ label, value, options, onChange, className = '' }) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <span className="text-[10px] uppercase tracking-wide text-slate-400">{label}</span>
      <div className="flex flex-wrap rounded-md border border-slate-700 bg-slate-950/40 p-0.5" role="group" aria-label={label}>
        {options.map((o) => (
          <button
            key={o.value}
            type="button"
            aria-pressed={value === o.value}
            onClick={() => onChange(o.value)}
            className={
              'rounded px-2 py-0.5 text-xs transition ' +
              (value === o.value ? 'bg-brand-600/15 text-brand-500' : 'text-slate-400 hover:text-slate-200')
            }
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
